<template>
  <div>
    <offers-form :is-active.sync="isAdding" @changed="offerAdded" />
    <data-table
      title="Overall Offers"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
      @click:row="showOfferDetails"
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Create an Offer
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>
    </data-table>
  </div>
</template>
<script>
import offersForm from "./form.vue";
export default {
  components: {
    offersForm,
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      offer: {},
      editingOffer: null,
      url: `api/v1/transactions/feeConfigurations/${this.$route.params.id}/offer`,
      headers: this.pairTableLabelWithValue({
        id: "id",
        Name: "name",
        "Fee Type": "fee_type.name",
      }),
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  computed: {
    feeConfigurationId() {
      return this.$route.params.id;
    },
  },

  methods: {
    showOfferDetails({ id }) {
      this.$router.push({
        name: "deposits.offers.show",
        params: { id, feeConfigurationId: this.feeConfigurationId },
      });
    },
    offerAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    offerUpdated({ message }) {
      this.editingOffer = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateOffer(offer) {
      this.editingOffer = Object.assign({}, offer);
      this.isEditing = true;
    },
  },
};
</script>
